import { FC, useCallback, useEffect, useState } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { useStyles } from "../styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import {
  daSelectAllStationsFilters,
  daSelectAllStatusFilters,
  daUpdateSettings,
  getAllDriversData,
} from "actions/daAndFleetActions";
import { MultipleSelectField } from "componentsNew/elements/MultipleSelectField";
import { daStatusConstants, DISPATCHER, MANAGER } from "constants/constants";
import { SearchInput } from "componentsNew/elements/SearchInput";
import { useDispatch } from "react-redux";
import { CustomDrawer } from "componentsNew/drawers/CustomDrawer";

import Tune from "@material-ui/icons/Tune";
import { DaTableSetitngsDrawerContent } from "componentsNew/drawers/drawerContent/DaTableSetitngsDrawerContent";
import { ModalWindow } from "componentsNew/modals/ModalWindow";
import { DaStatusChangeModalContent } from "componentsNew/modals/modalContent/DaStatusChangeModalContent";
import useResize from "hooks/useResize";

const DaHead: FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [search, setSearch] = useState<string>("");
  const { width } = useResize();
  const { userData } = useTypeSelectors((state) => state.auth);
  const {
    driverData: { driverListFilters, idListForUpdate },
  } = useTypeSelectors((state) => state.daAndFleets);

  const stations = Array.isArray(driverListFilters?.stations)
    ? driverListFilters?.stations?.join("_")
    : "";
  const statuses = Array.isArray(driverListFilters?.statuses)
    ? driverListFilters?.statuses?.join("_")
    : "";

  useEffect(() => {
    if (stations && statuses) {
      dispatch(
        getAllDriversData(
          driverListFilters?.pageNumber + 1,
          driverListFilters?.rowsPerPage,
          driverListFilters?.ordering,
          stations,
          statuses,
          search,
        ),
      );
    }
  }, [
    driverListFilters?.pageNumber,
    driverListFilters?.rowsPerPage,
    driverListFilters?.ordering,
    stations,
    statuses,
    search,
    dispatch,
  ]);

  const handleChangeStations = useCallback(
    (stations: number[]) => {
      dispatch(daUpdateSettings({ stations: stations }));
    },
    [dispatch],
  );

  const handleSelectAllStations = useCallback(
    () => dispatch(daSelectAllStationsFilters()),
    [dispatch],
  );

  const handleChangeStatuses = useCallback(
    (statuses: number[]) => {
      dispatch(daUpdateSettings({ statuses }));
    },
    [dispatch],
  );

  const handleSelectAllStatuses = useCallback(
    () => dispatch(daSelectAllStatusFilters()),
    [dispatch],
  );

  const stationOptions = userData.station_spots.map((spot) => ({
    value: spot.station.id,
    label: spot.station.title,
  }));

  return (
    <Box className={classes.paper}>
      <Box className={classes.filters}>
        <Box className={classes.filtersLeft}>
          <Box className={classes.filterBox}>
            <MultipleSelectField
              options={stationOptions}
              selected={driverListFilters?.stations}
              action={handleChangeStations}
              actionAll={handleSelectAllStations}
              label="Stations"
              allLabel="All Stations"
              autoSelectAll
              hideLabel={840 > width}
            />
            <MultipleSelectField
              options={daStatusConstants}
              selected={driverListFilters?.statuses}
              action={handleChangeStatuses}
              actionAll={handleSelectAllStatuses}
              label="Statuses"
              allLabel="All Status"
              autoSelectAll
              hideLabel={840 > width}
            />
          </Box>
          <Box className={classes.filterBox}>
            <SearchInput value={search} onChange={setSearch} />
            <CustomDrawer
              customWidth={width > 840 ? 440 : 256}
              buttonType={"custom"}
              drawer_name={`da-table-settings`}
              drawerTitle={`Table Settings`}
              customButtonElement={
                <Button className={classes.settingsBtn} variant={"outlined"}>
                  <Tune /> {width > 840 ? <Typography>Settings</Typography> : ""}
                </Button>
              }
              disableMobileFullWidth
            >
              <DaTableSetitngsDrawerContent />
            </CustomDrawer>
          </Box>
        </Box>
        <Box className={classes.filtersRight}>
          {idListForUpdate?.length ? (
            <Typography>{idListForUpdate.length} selected</Typography>
          ) : (
            ""
          )}
          <ModalWindow
            modal_name={"da-edit-status-modal"}
            buttonType={"button"}
            buttonText={"Change Status"}
            modalTitle={"Change Driver Status"}
            isDisabled={!idListForUpdate?.length || [DISPATCHER, MANAGER].includes(userData.role)}
          >
            <DaStatusChangeModalContent />
          </ModalWindow>
        </Box>
      </Box>
    </Box>
  );
};

export default DaHead;
